
import React, { useState, useEffect, useCallback } from "react";
import _ from "lodash";
import { Table, Modal, Form, Checkbox, Col, Row, Button} from "antd";
import NotificationAPI from 'restAPI/NotificationAPI';
import { LoadingIcon, SeverityIcons } from "components/Icons";
import { useForm } from 'antd/lib/form/Form'
import AuthorisedContainer from "components/AuthorisedContainer";
import { PermissionSetMap } from "constants/RBACConstants";
import AuthorisedSwitch from "components/AuthorisedSwitch";
import message from "components/CustomMessage";
import { useGlobalFilterContext } from "contexts/GlobalFilterContext";
// import { isReadOnlyUser } from 'utils/authService';
import SelectWithUserEmail from "components/SelectWithUserEmail";
import { emailValidator } from 'utils/formUtils';

const notificationType = "EMAIL";

const defaultColumns = {        
    isEnabled: false,
    isCritical: false,
    isHigh: false,
    isMedium: false,
    isLow: false,
    isInformational: false,
    fetureDisabled: false,
}

const data = [{
    key: '1',
    severityConfigType: 'REPORTS',
    severityConfigTypeText: 'Compliance',
    value: '--'
}, {
    key: '3',
    severityConfigType: 'ALERTS',
    severityConfigTypeText: 'Notifications',
    value: ''
}];


export default function EmailFormNew(){
    const [values, setValues] = useState({
        isEnabled: true,
        notificationType,
        userEmails: [],
        severityConfigDTOs:[]
    });
    const [form] = useForm();
    const [showPopUp, setShowPopUp] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const {globalFilterBusinessUnit} = useGlobalFilterContext()

    const getStatus = (severityConfigType) => {
        return (_.find(values.severityConfigDTOs,["severityConfigType",severityConfigType]))?.isEnabled;
    }

    const getFeatureStatus = (severityConfigType) => {
        if(typeof severityConfigType !== "string")
        {
            return true;
        }
        return (_.find(values.severityConfigDTOs,["severityConfigType",severityConfigType]))?.fetureDisabled;
    }

    const handleChange = (value,entity,checked) => {
        (_.find(values.severityConfigDTOs,["severityConfigType",_.toUpper(entity)]))[value] = checked;
        setValues({...values});
      }

    const getFieldRendering = (value,obj,fieldName) => {
        return obj.value !== '' ? obj.value : <Checkbox defaultChecked={value} disabled={!values.isEnabled || obj.fetureDisabled || !getStatus(obj.severityConfigType)} onChange={(event)=> handleChange(fieldName,obj.severityConfigType,event.target.checked)}></Checkbox>
    }

    const columns = [{
        title: 'Send Email for the following entities',
        dataIndex: 'severityConfigTypeText',
        render: (text, obj) => <><AuthorisedSwitch permission={PermissionSetMap.WRITE_TOOLS} checked={getStatus(obj.severityConfigType)} size="small" disabled={!values.isEnabled || getFeatureStatus(obj.severityConfigType)} onClick={(checked) => handleChange("isEnabled",obj.severityConfigType,checked)}/> {  text  } </>,
      }, {
      title: (<><SeverityIcons.Critical />  Critical</>),
        dataIndex: 'isCritical',
        render:(value,obj) => getFieldRendering(value,obj,'isCritical') 
      }, {
        title: (<><SeverityIcons.High />  High</>),
        dataIndex: 'isHigh',
        render: (value,obj) => getFieldRendering(value,obj,'isHigh')
      }, {
        title: (<><SeverityIcons.Medium />  Medium</>),
        dataIndex: 'isMedium',
        render:(value,obj) =>  getFieldRendering(value,obj,'isMedium')
      }, {
        title: (<><SeverityIcons.Low />  Low</>),
        dataIndex: 'isLow',
        render: (value,obj) => getFieldRendering(value,obj,'isLow')
      }, {
        title: (<><SeverityIcons.Info />  Info</>),
        dataIndex: 'isInformational',
        render: (value,obj) => getFieldRendering(value,obj,'isInformational')
      }];

    const getSeverityStatus = (severityConfig = []) => {
        return data.map((o)=>{
           return { ...o, ...defaultColumns, ...(o.key === "2" ? {fetureDisabled: true} : {}), ...((_.find(severityConfig,["severityConfigType",o.severityConfigType])) || {})};
        });
    }

    const fetchNotification = useCallback(() =>{
        const {promise, cancel} = NotificationAPI.getNotification();
        promise.then(response => {
        const {isEnabled,notificationType} = response || {};
        const userEmails = response  && response.users ? response.users.map(user => user) : [];
        const severityConfig = getSeverityStatus(response?.severityConfigDTOs);
        const stateObj = {
            isEnabled,
            notificationType,
            severityConfigDTOs: severityConfig,
            userEmails
        }
        form.setFieldsValue(stateObj);
        setValues(stateObj);
        })
        return cancel;
    }, [form]);

    useEffect(()=>{
        return fetchNotification();
    },[fetchNotification, globalFilterBusinessUnit])

    const onSave = async () => {
        try{
            setSubmitting(true);
            await NotificationAPI.createNotification(values).promise; 
            message.success('Configuration saved successfully');
        } catch(e){
            console.error(e);
        } finally {
            setSubmitting(false);
        }
    }

    function handleEmailChange(value) {
        values.userEmails = value.map((v) => { 
            return v.trim();
        });
        setValues({...values});
    }     
      
      function valueExists(value){
        const { validator } = emailValidator();
        if(!value.length && values.isEnabled){
            return Promise.reject(`Emails are required`);
        }
        return validator(null, value.map((v) => { 
            return v.trim();
        }));
    }
    
    return (
            <Form
                layout="horizontal"
                form={form}
                onFinish={onSave}
            >
                <Modal
                    okText="Confirm"
                    bodyStyle={{ padding: 0 }}
                    visible={showPopUp !== ''}
                    title={`Are you sure you want to ${showPopUp} Email integration?`}
                    onOk={() => {
                            setValues({...values, isEnabled: showPopUp === 'enable'})
                            setShowPopUp('')
                        }
                    }
                    onCancel={() => {
                            setShowPopUp('')
                        }
                    }
                />
                <Form.Item name="isEnabled" label="Enable Email Notification">
                    <AuthorisedSwitch permission={PermissionSetMap.WRITE_TOOLS} checked={values.isEnabled} onClick={(checked) => setShowPopUp(checked ? 'enable' : 'disable')}  size="small" />
                </Form.Item>
                <Form.Item name="userEmails" label="Send Email to specific people" rules={[{
                    validator: (rule, value) => valueExists(value)
                }]}>
                    <SelectWithUserEmail
                        showArrow
                        placeholder="Please select Email"
                        value={values.userEmails}
                        defaultValue={values.userEmails}
                        onChange={handleEmailChange}
                    />
                </Form.Item>
                <Form.Item name="severityConfigDTOs">
                <Table
                    columns={columns}
                    dataSource={values.severityConfigDTOs}
                    pagination={false}
                    size={"small"}
                    loading={{ spinning: _.isEmpty(values.severityConfigDTOs), indicator: <LoadingIcon />}}
                />

                </Form.Item>
                <Form.Item>
                    <Row>
                        <Col xl={18} lg={12}/>
                        <Col xl={6} lg={12} className={"text-right"}>
                            <AuthorisedContainer permission={PermissionSetMap.WRITE_TOOLS}>
                                <Button htmlType="submit" type="primary" className="m-t-l m-b-l" loading={submitting}>Save</Button>
                            </AuthorisedContainer>
                        </Col>
                    </Row>
                </Form.Item>
            </Form>
    )
}
